/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPersonalizedAdsState} from '../api'

 export const useQueryGetPersonalizedAdsState = createReactQueryHook('getPersonalizedAdsState', getPersonalizedAdsState)
